import { render, staticRenderFns } from "./cookieBotCookiePolicy.vue?vue&type=template&id=20e44306"
import script from "./cookieBotCookiePolicy.vue?vue&type=script&lang=js"
export * from "./cookieBotCookiePolicy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports